// # #############################################
// # Title : Radio Button
// # Authors : Sameer, Dhruv, Shubham, Mahesh
// # Date : 15th October 2019
// # Last Modified : Dhruv, August 2019
// # Version : 19.10.03
// # Description : This is the code for rendering the revenue charts on the simulation summary tab
// # ############################################

import React, { Component } from "react";
import Highcharts from "highcharts";
// import CircularProgress from "@material-ui/core/CircularProgress";
import { abbreviateNumber } from "../utils/helperFunction";
// import GlobalEvents from "../utils/global-events"

class Revenue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      yAxis: "Revenue",
      suffix: ""
    };
  }

  componentDidMount() {
    this.loadRevenue(this.state.data, this.state.suffix);
    if (this.props.graph === 'brand_penetration') {
      this.props.subscribe_ns(this.props.ns_value, data => {
        let copyData = JSON.parse( JSON.stringify(data))
        let yourBrandData = copyData.filter(obj => obj.name === "YourBrand")
        let compData = copyData.filter(obj => obj.name !== "YourBrand").sort((a, b) => (a.name > b.name) ? 1 : -1)
        let sortedData = [...yourBrandData, ...compData]
        let numAgents = sessionStorage.getItem("namespace") === "simulation" ? parseInt(sessionStorage.getItem("no_of_agents")) : parseInt(JSON.parse(sessionStorage.getItem("scenarioDetail"))[0].numAgents)
        numAgents = (isNaN(numAgents)) ? 5000 : numAgents;
        sortedData.forEach(
          object => {
            object.data = object.data.map(arr => [arr[0], parseFloat((arr[1] * 100 / numAgents).toFixed(2))])
          }
        )
        this.setState({
          data: sortedData,
          yAxis: "Penetration %",
          suffix: "%"
        });
      });
    }
    else {
      this.props.subscribe_ns(this.props.ns_value, data => {
        let yAxis = this.props.ns_value.includes("revenue")
          ? "Revenue"
          : "Units Sold";
        for (let i = 0; i < data.length; i++) {
          if (data[i].data) {
            data[i].data = data[i].data.sort(this.Comparator);
          }
        }

        let tempData = []

        data.forEach(d => {
          let temp = d.name.split('_')
          if (temp[1]) {
            tempData[parseInt(temp[1])] = d;
          }
          else {
            tempData[0] = d;
          }
        })
        this.setState({
          data: tempData,
          yAxis: yAxis,
          suffix: ""
        });
      });
    }

  }

  Comparator(a, b) {
    if (parseInt(a[0]) < parseInt(b[0])) return -1;
    if (parseInt(a[0]) > parseInt(b[0])) return 1;
    return 0;
  }

  componentDidUpdate() {
    this.loadRevenue(this.state.data, this.state.suffix);
  }

  loadRevenue(data, suffix) {
    if (this.state.data.length > 0) {

      Highcharts.chart(this.refs.Revenue, {

        chart: {
          animation: false,
          backgroundColor: "whitesmoke"
        },

        title: {
          text: this.state.yAxis + " - Your Brand vs Competitors"
        },

        tooltip: {
          // Tooltip Options
          enabled: true,
          formatter: function () {
            // eslint-disable-next-line
            return this.series.name + ': <b>' + abbreviateNumber(this.y) + suffix + '</b> ' + '<br />' + `Day: <b>` + this.x + `</b>`;
          }
        },

        xAxis: {
          title: {
            text:
              "Days"
          }
        },

        credits: {
          enabled: false
        },

        yAxis: {
          title: {
            text: this.state.yAxis
          }
        },

        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle"
        },

        plotOptions: {
          series: {
            animation: false,
            marker: { radius: 2 },
            label: {
              connectorAllowed: false
            },
            pointStart: sessionStorage.getItem("currentTick") <= "26" ? 0 : 1
          }
        },

        series: this.state.data,

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom"
                }
              }
            }
          ]
        }
      });
    }
  }

  render() {
    if (this.state.data.length > 0) {
      return <div key={`${new Date()}`} style={{ paddingTop: "10px" }} ref="Revenue" />;
    } else if (sessionStorage.getItem("simStarted") === "true") {
      return (
        <div className="graphLoader">
          {/* <CircularProgress size={80} /> */}
          <div id={"loaderContainerGraphs"}>
            <div class="lds-facebook-graphs"><div></div><div></div><div></div></div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="noSimText">
          Start simulation in order to view results
        </div>
      );
    }
  }
}

export default Revenue;
